"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEVICE_TAG_DIMENSION_PREFIX_REGEX = exports.DEVICE_TAG_DIMENSION_PREFIX = exports.ASSET_TAG_CATEGORY_LABEL = void 0;
exports.augmentMeasurementsWithAssetTags = augmentMeasurementsWithAssetTags;
exports.getAssetTagDimensionKey = getAssetTagDimensionKey;
exports.getAssetTagKeysByDisplayName = getAssetTagKeysByDisplayName;
exports.getTagNameFromDimensionKey = getTagNameFromDimensionKey;
exports.isAssetTagDimensionKey = isAssetTagDimensionKey;
exports.transformAssetTagDimensions = transformAssetTagDimensions;
// User-facing label — update here when final naming is confirmed
const ASSET_TAG_CATEGORY_LABEL = exports.ASSET_TAG_CATEGORY_LABEL = 'Asset Tags';

// Internal dimension key prefix — must NOT change (persisted in dashboards, alerts, saved filters)
const DEVICE_TAG_DIMENSION_PREFIX = exports.DEVICE_TAG_DIMENSION_PREFIX = 'i_device_tags ->> ';
const DEVICE_TAG_DIMENSION_PREFIX_REGEX = exports.DEVICE_TAG_DIMENSION_PREFIX_REGEX = new RegExp(`^${DEVICE_TAG_DIMENSION_PREFIX}'\\w+'$`);
function isAssetTagDimensionKey(dimensionKey) {
  return DEVICE_TAG_DIMENSION_PREFIX_REGEX.test(dimensionKey);
}
function getAssetTagDimensionKey(tagName) {
  return `${DEVICE_TAG_DIMENSION_PREFIX}'${tagName}'`;
}
function getTagNameFromDimensionKey(dimensionKey) {
  if (!dimensionKey.startsWith(DEVICE_TAG_DIMENSION_PREFIX)) {
    return undefined;
  }
  const raw = dimensionKey.slice(DEVICE_TAG_DIMENSION_PREFIX.length);
  if (raw.startsWith("'") && raw.endsWith("'")) {
    return raw.slice(1, -1);
  }
  return raw;
}
function transformAssetTagDimensions(tags) {
  return tags.reduce((acc, tag) => {
    acc[getAssetTagDimensionKey(tag.name)] = {
      Label: tag.display_name,
      Column: getAssetTagDimensionKey(tag.name),
      Alias: tag.name,
      Type: 'string',
      Category: ASSET_TAG_CATEGORY_LABEL
    };
    return acc;
  }, {});
}
function getAssetTagKeysByDisplayName(measurements) {
  if (!measurements.length) {
    return {};
  }
  const result = {};
  for (const [key, dim] of Object.entries(measurements[0].storage.Dimensions)) {
    if (key.startsWith(DEVICE_TAG_DIMENSION_PREFIX) && dim.Label) {
      result[dim.Label] = key;
    }
  }
  return result;
}
function augmentMeasurementsWithAssetTags(measurements, tags) {
  if (!tags.length) {
    return measurements;
  }
  const tagDimensions = transformAssetTagDimensions(tags);
  return measurements.map(measurement => ({
    ...measurement,
    storage: {
      ...measurement.storage,
      Dimensions: {
        ...measurement.storage.Dimensions,
        ...tagDimensions
      }
    }
  }));
}